export default "__VITE_ASSET__H2eMkwrX__"